<template>
  <div class="col-lg-12 p-0 range-input-1">
    <label class="h5 range-input-1-label" :for="inputConfig.id" v-html="inputConfig.title"> </label>
    <p v-html="inputConfig.description"></p>

    <div class="form-group range-input-1-input-parent">
      <div v-if="formAnswer[inputConfig.id] != null" class="mb-1 btn btn-primary range-input-1-value rounded-pill">
        {{ formAnswer[inputConfig.id] }}
      </div>

      <input type="range" class="form-control-range range-input-1-range-input"
             dir="ltr"
             v-model="formAnswer[inputConfig.id]"
             :min="inputConfig.config.min"
             :max="inputConfig.config.max"
             :step="inputConfig.config.step"
             :style="{ background: staticBackgroundColor }"
             :required="true">

      <!-- Labels container for three section tick marks -->
      <div class="range-labels">
        <span class="range-label ">{{ inputConfig.config.max }}%</span>
        <span
            class="range-label ">{{ (parseInt(inputConfig.config.max) + parseInt(inputConfig.config.min)) / 2 }}%</span>
        <span class="range-label ">{{ inputConfig.config.min }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: "RangeInput1",
  props: {
    inputConfig: {},
    formAnswer: {}
  },
  computed: {
    staticBackgroundColor() {
      const value = this.formAnswer[this.inputConfig.id] || 0;

      if (value >= 90) {
        return "green"; // 90-100%
      } else if (value >= 80) {
        return "yellow"; // 80-90%
      } else {
        return "red"; // 0-80%
      }
    }
  },
  mounted() {
    this.formAnswer[this.inputConfig.id] = this.inputConfig.config.min;
  }
});
</script>

<style scoped>
.range-input-1-range-input {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  background-size: 100% 8px;
}

.range-input-1-range-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
}

.range-input-1-range-input::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
}

.range-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}

.range-label {
  text-align: center;
  background: var(--secondary);
  padding: 0 10px;
  border-radius: 4px;
  margin-top: 5px;
}
</style>
